import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AdminSidebar } from './AdminSidebar';
import { AdminHeader } from './AdminHeader';
import { ENTERPRISE_ADMIN_BASE } from '../../config/adminLayers';

/**
 * Classic (legacy) admin shell — original flat nav and styling.
 * All existing admin routes render inside this layout. Behavior preserved.
 */
export const ClassicAdminLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navigation = [
    { name: 'Dashboard', href: '/admin/dashboard', icon: 'Home' },
    { name: 'Users', href: '/admin/users', icon: 'Users' },
    { name: 'Workspaces', href: '/admin/workspaces', icon: 'Building' },
    { name: 'Pricing', href: '/admin/pricing', icon: 'DollarSign' },
    { name: 'Invoices', href: '/admin/invoices', icon: 'Invoice' },
    { name: 'Subscriptions', href: '/admin/subscriptions', icon: 'Subscription' },
    { name: 'Phone Numbers', href: '/admin/phone-numbers', icon: 'Phone' },
    { name: 'Calling Providers', href: '/admin/calling-providers', icon: 'Calling' },
    { name: 'API Keys', href: '/admin/api-keys', icon: 'Key' },
    { name: 'Workflows', href: '/admin/workflows', icon: 'Workflow' },
    { name: 'Workflow Health', href: '/admin/workflow-health', icon: 'Monitoring' },
    { name: 'Integrations', href: '/admin/integrations', icon: 'Plug' },
    { name: 'Settings', href: '/admin/settings', icon: 'Sliders' },
    { name: 'System', href: '/admin/system', icon: 'Settings' },
    { name: 'Monitoring', href: '/admin/monitoring', icon: 'Monitoring' },
    { name: 'FastAPI Monitoring', href: '/admin/fastapi-monitoring', icon: 'Terminal' },
    { name: 'Copilot metrics (Prometheus)', href: '/admin/copilot-metrics', icon: 'BarChart3' },
    { name: 'Jarvis tools', href: '/admin/jarvis-tools', icon: 'Terminal' },
    { name: 'Supabase Monitor', href: '/admin/supabase-monitor', icon: 'Database' },
  ];

  return (
    <div className="min-h-screen bg-admin-50">
      <AdminSidebar
        navigation={navigation}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        promoteLink={{
          label: 'Enterprise console',
          href: ENTERPRISE_ADMIN_BASE,
          description: 'New layout & upcoming features',
        }}
      />

      <div className="lg:pl-64">
        <AdminHeader setSidebarOpen={setSidebarOpen} navigation={navigation} />

        <main className="py-6">
          <div className="mx-auto px-4 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};
